import * as React from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

type omitedTooltipProps = Omit<TooltipProps, "children" | "title">;

interface Props extends omitedTooltipProps {
  text: string;
  isError?: boolean;
  open?: boolean;
  handleClose?: () => void;
  handleOpen?: () => void;
}

export default function ArrowTooltips(props: Props) {
  const { text, isError, open, handleClose, handleOpen, ...rest } = props;

  return (
    <Tooltip
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      title={text}
      arrow
      placement="top"
      role="tooltip"
      id="tooltipContainer"
      {...rest}
    >
      {isError ? (
        <div>
          <i className="fa-solid fa-triangle-exclamation text-red-500"></i>
        </div>
      ) : (
        <span
          className="border w-4 h-4 text-gray-500 text-[10px] flex items-center justify-center rounded-full"
          onClick={handleOpen}
          aria-describedby="tooltipContainer"
        >
          i
        </span>
      )}
    </Tooltip>
  );
}
